import * as React from 'react'
import { useSandboxState } from '../layouts/page/page.context'
import MdxRenderer from '../components/mdx-renderer/mdx-renderer.component'

const SandboxByKey: React.FC<{ sandboxKey?: string | null }> = ({ sandboxKey }) => {
  const mdx = useSandboxState(sandboxKey)
  if (!mdx) return null
  return <MdxRenderer mdx={mdx} />
}

export default SandboxByKey
